<template>
  <div class="coupon-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <div class="form-group row header-custom-switch">
            <div class="col-sm-10 col-form-label uppercase">
              <strong>
                <h3>
                  <router-link :to="{ name: 'menu_attribute_list'}" class="float-left mr-1 main-link">{{$t('menu.menu-attribute')}}</router-link> / {{$t('coupon.detail')}}
                </h3>
              </strong>
            </div>

            <legend class="col-sm-2 col-form-label">
              <span style="margin-right: 15px;">
                {{$t('menu.active')}}
              </span>
              <c-switch style="margin-top: 0" class="active" type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="item.active" :value="1" :uncheckedValue="0" />
            </legend>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">

          <!-- Basic information -->
          <b-card header-tag="header" footer-tag="footer" class="header">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('coupon.basic_information') }}</strong>
                <label class="switch switch-sm switch-text switch-info float-right" @click="updateBasicInformationStatus" v-b-toggle.basic_information_content>
                  <i class="fa fa-sort-down" v-if="basicInformationStatus"></i>
                  <i class="fa fa-sort-up" v-if="!basicInformationStatus"></i>
                </label>
            </div>
            <b-collapse :visible.sync="basicInformationStatus" id="basic_information_content">
              <b-form class="row">
                <b-col cols="12">
                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">{{$t('menu-attribute.name')}}</legend>
                    <div v-for="lang in $store.getters.languages" class="col-sm-5" :key="lang.id" >
                      <b-form-input
                        v-model="item.name[lang]"
                        v-bind:placeholder="$t('common.text_'+lang)"
                        :state="!$v.item.name.$invalid"
                        :name="`name[${lang}]`" />
                      <b-form-invalid-feedback :id="'name-feedback'">
                        <p class="help is-danger" v-if="!$v.item.name.required">{{ $t('message.required_filed') }}</p>
                      </b-form-invalid-feedback>
                    </div>
                  </div>
                  <div class="form-group row" v-if="config_attribute_combo">
                  <legend class="col-sm-2 col-form-label">{{$t('menu-attribute.type')}}</legend>
                    <b-form-group class="col-md-5">
                      <b-form-select class="border-radius-4px form-control"
                        v-model="item.type"
                        :options="types[$session.get('lang')]"
                        :disabled="item.uuid ? true : false"
                        />
                    </b-form-group>
                  </div>

                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">{{$t('menu-attribute.sequence')}}</legend>
                    <div class="col-sm-10" >
                      <b-form-input type="number"
                                    class="form-control"
                                    v-model="item.sequence"
                                    v-bind:placeholder="$t('coupon.sequence')" :state="!$v.item.sequence.$invalid"
                                    aria-describedby="sequence-feedback"/>
                    </div>
                  </div>

                  <div class="form-group row">
                    <div class="coupon-image col-sm-6" v-for="(data, image) in imageData" :key="data.id">
                      <legend class="col-sm-4 col-form-label">
                        {{ $t('menu-attribute.image_'+image) }}
                        <!-- <i class="fa fa-info-circle text-primary" :id="'image-' + image"></i> -->
                        <b-tooltip :target="'image-' + image" placement="top">
                          <div class="text-left" v-html="getImageHelpInfo('menu_attribute', image)"></div>
                        </b-tooltip>
                      </legend>
                      <div class="col-sm-8">
                        <b-form-file :id="image" @change="previewImage" accept="image/*"
                        :placeholder="$t('message.choose_a_file')"></b-form-file>

                        <div v-bind:class="'image-' + image + '-preview img-min-height'">
                          <img class="previewImage" v-bind:src="data">
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-4 remove-section" >
                        <i class="fa fa-trash-o text-main pointer" @click="removeImage()" ></i>
                    </div>
                  </div>
                </b-col>
              </b-form>
            </b-collapse>
          </b-card>
          <!-- Basic information -->

          <div slot="footer" class="card-footer">
            <router-link :to="{ name: 'menu_attribute_list', query: {rollback: 1}}" class="btn border-radius-4px bg-main float-left ml-4"><i class="fa fa-arrow-left"></i> {{$t('common.back')}}</router-link>
            <div class="btn-save">
              <b-button :disabled="$v.item.$invalid || !validName" variant="success" v-on:click="saveMenuAttribute()">&nbsp; {{ $t('common.save')}}</b-button>
            </div>
          </div>

        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {validationMixin} from 'vuelidate'
import {required,between } from 'vuelidate/lib/validators'
import cSwitch from '../../../components/Switch'
import MaskedInput from 'vue-text-mask'
import DatePicker from 'vue2-datepicker'

let vm = null

export default {
  props: {
    id: {
      type: String,
      required: true,
      default: 'create'
    }
  },
  components: {
    cSwitch,
  },
  data: function () {
    return {
      prefix_crm_url: this.$store.getters.config.main.base_site_url,
      config_attribute_combo: this.$store.getters.config.gms.combo.config.combo_attributes ? this.$store.getters.config.gms.combo.config.combo_attributes : false,
      itemLimit: 10000,
      images: ['icon'],
      isProcessing: false,
      item: {
        uuid: "",
        name:{},
        active:1,
        sequence: 0,
        image: {},
        type: 1
      },
      types: [],
      basicInformationStatus: true,
      imageData: {},
      languages: Object.keys(this.$i18n.messages),
      validName: false,
      validImage: false,
      isRemoveImage: false
    }
  },
  mixins: [
    validationMixin
  ],
  computed: {
    rules() {
      return {
        name: {
          required,
        },
        sequence: {
          between: between(0, 999999999)
        },
      }
    }
  },
  validations() {
    return {
      item: this.rules
    }
  },
  methods: {
    updateBasicInformationStatus () {
      this.basicInformationStatus = this.basicInformationStatus?false:true
    },
    initialImage(){
      let data = {}
      for (let i in vm.images) {
        data[vm.images[i]] = ""
      }
      vm.imageData = data
    },
    removeImage() {
      this.initialImage()
      this.isRemoveImage = true
    },
    saveMenuAttribute () {
      vm.$bus.$emit('loading', 'block')
      vm.isProcessing = true;
      let oldUrl = []
      let formData = new FormData()
      for (let i in vm.item.image) {
        if (vm.item.image[i] && vm.item.image[i].type) {
          formData.append(i, vm.item.image[i])
        }
        else{
          if (!vm.isRemoveImage) {
            oldUrl[i] = vm.item.image[i]
          }
        }
      }
      let config = {headers: {'Content-Type': 'multipart/form-data'}}

      //call an API to save imag
      vm.axios.menu.uploadMenuAttributeImages(formData, config, function(response){
        vm.item.image={}
        if(response.data.status===true){
          vm.initialImage()

          for (let i in response.data.data.item) {
            vm.item.image[i] = response.data.data.item[i]
            vm.imageData[i] = response.data.data.item[i]
          }
          //get old url
          for (let i in oldUrl) {
            vm.item.image[i] = oldUrl[i]
            vm.imageData[i] = oldUrl[i]
          }

          if (vm.id == 'create' || vm.id == undefined) {
            vm.axios.menu.createMenuAttribute(vm.item, function(response){
              vm.$toastr.success(vm.$t('message.save_successful'), vm.$t('message.success'), {})
              vm.isProcessing = false
              vm.$router.push({name: 'menu_attribute_list'})
            }, function(){
              vm.isProcessing = false
            });
          } else {
            vm.axios.menu.updateMenuAttribute(vm.item, function(response){
              vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
              vm.isProcessing = false
            }, function(){
              vm.isProcessing = false
            });
          }
        }
        vm.$bus.$emit('loading', 'none')
      }, function(error){
        vm.$bus.$emit('loading', 'none')
      })
    },
    previewImage (event) {
      let input = event.target
      if (input.files && input.files[0]) {
        let reader = new FileReader()
        reader.onload = (e) => {
          vm.imageData[input.id] = e.target.result
        }
        let data = {}
        for (let i in vm.images) {
          data[vm.images[i]] = vm.imageData[vm.images[i]]
        }
        vm.imageData = data
        reader.readAsDataURL(input.files[0])
        vm.item.image[input.id] = input.files[0]
        vm.validImage = true
      } else {
        vm.validImage = false
      }
    },
    getMenuAttributeDetail()
    {
      vm.isProcessing = true
      if(!vm.id) return

      //get menu attribute detail
      vm.axios.menu.getMenuAttribute(vm.id, function(response){
        vm.item = response.data.data.item
        vm.mappingMenuAttributeImage(vm.item)
      }, function(error){
      })
    },
    mappingMenuAttributeImage (menuAttribute) {
      for (let i in vm.images) {
        vm.imageData[vm.images[i]] = menuAttribute.image[vm.images[i]] != null ? menuAttribute.image[vm.images[i]] : ''
      }
      if (vm.imageData.icon !== undefined && vm.imageData.icon !== "") {
        vm.validImage = true
      }
    },
    setLangType() {
      let langs = Object.keys(vm.$i18n.messages)
      for (let l in langs) {
        vm.types[langs[l]] = [
          {text: vm.$t('common.single', langs[l]), value: 1},
          {text: vm.$t('common.combo', langs[l]), value: 2}
        ]
      }
    }
  },
  created: function () {
    vm = this
    this.setLangType()
  },
  watch: {
    'item.name': {
      handler(name){
        vm.validName = false
        let langs = vm.languages
        for (let l in langs) {
          if (name[langs[l]] !== undefined && name[langs[l]] != "") {
            vm.validName = true
          }
        }
      },
      deep: true
    }
  },
  updated: function () {
    if (vm.id != 'create' && vm.id !== undefined
      && !vm.isProcessing) {
      vm.item.uuid = vm.id
      vm.getMenuAttributeDetail()
    }
  },
  mounted: function(){
    vm.initialImage()
  }
}
</script>

<style>
  .coupon-form input,
  .coupon-form textarea,
  .coupon-form select,
  .coupon-form .multiselect__tags {
      border-radius: 4px !important;
  }

  .multiselect__tags{
      border-radius: 0 !important;
  }

  .fa.fa-trash-o {
    font-size: 30px;
    line-height: 35px;
  }

  .is-invalid .multiselect__tags {
      border-color: #f86c6b;
  }


  .coupon-form .btn-secondary{
    border-radius: 3px;
  }

  /*checkbox style*/
  .coupon-form  .form-check:after,
  .coupon-form .form-check:before {
      content: " ";
      display: table;
      content: "";
      line-height: 0;
  }

  .coupon-form .form-check input[type="checkbox"] {
      opacity: 0;
      z-index: 1;
      cursor: pointer;
  }

  .coupon-form .form-check label {
      min-height: 20px;
      padding-left: 15px;
      cursor: pointer;
      display: inline-block;
      max-width: 100%;
      margin-bottom: 5px;
      font-weight: normal;
      vertical-align: middle;
      position: relative;
  }

  .coupon-form .form-check label::before {
      border-radius: 50%;
      content: "";
      display: inline-block;
      position: absolute;
      width: 20px;
      height: 20px;
      left: 0;
      margin-left: -10px;
      border: 1px solid #cccccc;
      background-color: #fff;
      -webkit-transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
      -o-transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
      transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
  }

  .coupon-form .form-check input[type="checkbox"]:checked + label::before {
      background-color: #0086FF;
      border-color: #0086FF;
  }

  .coupon-form .form-check .form-check-input:disabled ~ label {
    cursor: not-allowed;
  }

  .coupon-form .form-check input[type="checkbox"]:checked + label::after {
      font-family: 'FontAwesome';
      content: "\f00c";
      color: #fff;
  }

  .coupon-form .form-check label::after {
      display: inline-block;
      position: absolute;
      width: 16px;
      height: 16px;
      left: 0;
      top: 0;
      margin-left: -10px;
      padding-left: 4px;
      padding-top: 1px;
      font-size: 12px;
      color: #0086FF;
  }
  /*checkbox style*/
  .coupon-form #customize-field .col-sm-10
  {
    padding-left: 8px;
  }

  .coupon-form .form-check-inline{
    margin-right: 1rem;
  }

  .coupon-form .modal-lg{
    max-width: 95%;
    margin-top: 0;
  }

  .coupon-form .modal-body{
    padding: 0 1rem;
  }

  .coupon-form .padding-none{
    padding: 0;
  }

  .applicable-store label span{
    width: 48px;
  }

  .applicable-store select{
    margin-right: 20px;
  }
  .not_apply_date .mx-input-append {
    display: none!important;
  }

  .not_apply_date .mx-calendar-header {
    width: 100%!important;
  }
  .not_apply_date .mx-calendar-content {
    width : 100%!important;
    height: 100%!important;
  }
  .not_apply_date .mx-time-list{
    height: 225px;
  }

</style>

<style scoped>
  #application_result_content .gray-background{
    border-radius: 0;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }

  #application_result_content .gray-light-background{
    border-radius: 0;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }

  /*input file */
  .file-select > .select-button {
    padding: 7px;
    color: white;
    border-radius: .2rem;
    text-align: center;
    font-weight: bold;
    background: #0086FF !important;
    border-color: #0086FF !important;
    cursor: pointer;
    margin-top: 3px;
  }

  .file-select > input[type="file"] {
    display: none;
  }
  /*input file*/

  .applicable-store input{
    margin-top: 5px;
  }

  .switch-custom{
    max-width: 5.3%;
  }

  .table-bordered{
    margin-top: 10px;
  }

  .table-bordered thead{
    background-color: #E1E6EB;
  }

  .table-bordered tbody{
    background-color: #F4F6F8;
  }

  .table-bordered th{
    border: none;
  }

  .table-bordered .center{
    text-align: center;
  }

  .col-sm-2-custom{
    flex: 0 0 12.66667%;
    margin-top: 2px;
    text-align: center;
  }

  .col-sm-2-custom-display-inline{
    flex: 0 0 12.66667%;
    margin-top: 2px;
    text-align: center;
    display: inline-flex;
  }

  .coupon-form .btn-save{
    float: right;
    margin-right: 22px;
  }

  .coupon-form .switch.switch-icon{
    margin-top: 5px;
  }

  .coupon-form .header-custom{
    margin-top: 15px;
  }

  .coupon-form .header-custom-switch{
    margin-top: 5px;
    margin-bottom: 0;
  }

  .coupon-form .header-custom-switch .uppercase{
    display: inline-flex;
  }

  .coupon-form .header-custom-switch .col-form-label{
    text-align: right;
  }

  .coupon-form .header-custom-switch .active{
    float: right;
  }

  .coupon-form div.header,
  .coupon-form .header .card-header{
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
  }

  .coupon-form .card-footer{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 7.75px;
    border-top: none;
    margin-top: 1.5rem;
    z-index: 999;
  }

  .coupon-form .add-more{
    padding-left: 0;
  }

  .gray-background .form-control{
    /*padding: 8px;*/
    border: 1px solid gray;
  }

  .gray-background{
    background: #E1E6EB;
    padding: 15px;
    border-radius: 5px;
    border: 1px solid #DDE2E8;
  }

  .gray-light-background{
    background: #F4F6F8;
    padding: 15px;
    border-radius: 5px;
    border: 1px solid #DDE2E8;
  }

  .gray-background .row{
    margin-bottom: 0px;
  }

  .remark .btn-danger{
    margin-top: 7px;
    background-color: #fff;
  }

  .gray-light-background .btn-danger,
  .table-bordered .btn-danger{
    background-color: #F4F6F8;
  }

  .table-bordered .btn-danger{
    margin-top: 4px;
  }

  .gray-background .btn-danger{
    background-color: #E1E6EB;
  }

  .gray-background .btn-danger .fa,
  .gray-light-background .btn-danger .fa,
  .remark .btn-danger .fa,
  .table-bordered .btn-danger .fa{
    color: #0086FF;
    font-size: 20px;
  }

  .gray-background .col-sm-10,
  .gray-light-background .col-sm-10,
  .gray-light-background .col-sm-5{
    padding-left: 5px;
  }

  .margin-top20{
    margin-top: 20px;
  }

  .margin-bottom10{
    margin-bottom: 10px;
  }

  .clear-both{
    margin-bottom: 15px;
  }

  .card{
    margin-bottom: 0;
  }

  .coupon-image{
    margin: 0;
    padding: 0;
    display: inline-flex;
  }

  .coupon-image img{
    width: 100%;
  }

  .coupon-properties legend{
    width: auto;
    resize: both;
  }

  .coupon-properties .check-is-member{
    max-width: 16%;
  }

  .preview-image {
    width: 100%;
  }

  .font-size-inherit {
    font-size: inherit;
  }

</style>



// WEBPACK FOOTER //
// src/views/admin/menu-attribute/BaseForm.vue